<template>
  <div id="CommoditySearch">
    <!-- 中国进口：一站式采购与物流解决方案 -->
    <h1 v-if="shopGroupSeoH1Key" class="sr-only">
      {{ $fanyi(shopGroupSeoH1Key) }}
    </h1>
    <Dialog ref="dialog" :config="config">
      <!-- <span>插槽内容</span> -->
    </Dialog>
    <HomePageTop ref="head"></HomePageTop>
    <keywordSearch ref="keywordSearchRef" @filterData="filterData" />
    <noData v-if="goodsListIsNull1688 || goodsListIsNullTaobao" />
    <div v-else>
      <!-- 搜索结果块状 -->
      <div class="SearchConterCrosswise" v-loading="loading" v-if="Crosswise">
        <!-- $%2 -->
        <router-link
          :to="
            $fun.productDetailsPath(
              item.goods_id,
              item.shop_type,
              'LP=' + encodeURIComponent(listPageKeyword),
            )
          "
          class="SearchConterCrosswiseCon"
          v-for="(item, index) in showList"
          :key="index"
          target="_blank"
        >
          <!-- <button
          class="similarProducts"
          @click="
            $store.commit('getsearchImg', item.imgUrl);
            $fun.routerToPage('/CommoditySearch?type=imgSearch');
            $router.go(0);
          "
        >
          {{ $fanyi("查看相似") }}
        </button> -->
          <!-- 放图片的div -->
          <div class="SearchConterCrosswiseImg">
            <!-- 遮罩 -->
            <!-- <div class="shade" @click="$fun.toCommodityDetails(item.goods_id)">
            <div><img src="../../assets/newImg/搜索小.png" alt="" /></div>
          </div> -->
            <!-- <img class="goodsImg" :src="item.imgUrl" /> -->
            <el-image :src="item.imgUrl" class="biggoodsImg">
              <div slot="error" class="image-slot">
                <i class="el-icon-picture-outline"></i>
              </div>
              <div slot="placeholder">
                <i class="el-icon-loading"></i>
              </div>
            </el-image>
            <!-- <loadingImg :src="item.imgUrl" /> -->
          </div>
          <!-- 显示其他信息的div -->
          <div class="rests">
            <p class="goodsTitle" :title="item.title">{{ item.title }}</p>
            <p class="flex acenter">
              <span
                >{{
                  $fun.EURNumSegmentation(
                    $fun.ceil(item.goodsPrice * $store.state.exchangeRate),
                  )
                }}€</span
              >{{ $fun.RMBNumSegmentation(item.goodsPrice) }}￥
            </p>
            <template v-if="shopType != 'alibaba'">
              <div class="totalTagBox mt-16">
                {{ $fanyi("每月销售") }}: {{ item.monthSold }}
                {{ $fanyi("件") }}
              </div>
              <div class="totalTagBox">
                {{ $fanyi("回购率") }}: {{ item.repurchaseRate }}%
              </div>
            </template>
          </div>
        </router-link>
      </div>
      <!-- 搜索结果横向 -->
      <div class="SearchConterVertical" v-loading="loading" v-else>
        <div
          @click="
            $router.push($fun.productDetailsPath(item.goods_id, item.shop_type))
          "
          v-for="(item, index) in showList"
          :key="index"
        >
          <el-popover placement="right" trigger="hover">
            <img
              :src="item.imgUrl"
              alt=""
              style="width: 300px; height: 300px"
            />
            <el-image
              class="goodsImg hengxiang"
              :src="item.imgUrl"
              style="width: 160px; height: 160px"
              slot="reference"
            >
              <div slot="error" class="image-slot">
                <i class="el-icon-picture-outline"></i>
              </div>
              <div slot="placeholder">
                <i class="el-icon-loading"></i>
              </div>
            </el-image>
          </el-popover>

          <!-- <img class="goodsImg" src="../../assets/newImg/加载中.gif" /> -->
          <div class="VerticalInfo">
            <span class="vGoodsTitle">{{ item.title }}</span>
            <span
              >{{
                $fun.EURNumSegmentation(
                  $fun.ceil(item.goodsPrice * $store.state.exchangeRate),
                )
              }}€
              <span class="RMBPrice"
                >{{ $fun.RMBNumSegmentation(item.goodsPrice) }}￥</span
              >
              <font
                >{{ $fanyi("销量") }}：{{ item.sales }} {{ $fanyi("件") }}
              </font>
            </span>
          </div>
          <span
            v-if="shopType != 'alibaba'"
            class="collect"
            @click.stop="favoriteGoodsAdd(item)"
          >
            <div>
              <img
                v-if="item.goodsFavoriteStatus"
                src="../../assets/SearchResultsPage/Collected.png"
              />
              <img v-else src="../../assets/SearchResultsPage/collection.png" />
            </div>
            <span> {{ $fanyi("收藏") }}</span>
          </span>
        </div>
      </div>
      <!-- 加载中提示 -->
      <div class="loadingProBox" v-if="shopType == 1688 && !finished1688">
        <i class="el-icon-loading"></i>
        <span>{{ $fanyi("加载中") }}</span>
      </div>
    </div>

    <Foot></Foot>
  </div>
</template>
<script>
import keywordSearch from "./components/model-keywordSearch.vue";
import noData from "./components/model-noData.vue";
import Foot from "../../components/foot/Foot.vue";
import Dialog from "../../components/public/Dialog";
import HomePageTop from "../../components/head/HomePageTop.vue";
import { getShopGroupCategoryH1Key } from "@/utlis/pageSeoMap";
export default {
  data() {
    return {
      form1688: {
        page: 0,
        pageSize: 20,
      }, //搜索条件
      list1688: [],
      goodsListIsNull1688: false,
      finished1688: false,
      total1688: 0,
      formTaobao: {
        page: 0,
        pageSize: 20,
      }, //淘宝搜索条件
      listTaobao: [],
      goodsListIsNullTaobao: false,
      finishedTaobao: false,
      totalTaobao: 0,

      shopType: "1688",
      fiData: {
        region: "",
      },

      // 展示数据
      showList: [],
      total: 0,

      keyWord: "",

      loading: true,
      tiShi: this.$fanyi("加载中"), //提示语句
      // 是否是横版
      Crosswise: true,
      isImgSearch: false,
      notCreate: true,
      timeout: false,
      config: {
        top: "20vh",
        width: "500px",
        title: this.$fanyi("提示"),
        btnTxt: [this.$fanyi("确定")],
      },

      loadKey: 1,
      // 接口返回的无结果文案覆盖（如 code 10010），与 i18n 默认文案分开存
      nodataFontOverride: null,
    };
  },
  components: {
    HomePageTop,
    Foot,
    Dialog,
    noData,
    keywordSearch,
  },
  computed: {
    // shop 接口动态分类页 SEO h1（sr-only，与首页一致）
    shopGroupSeoH1Key() {
      return getShopGroupCategoryH1Key(this.$route);
    },
    /** 列表页关键词，用于商品详情 LP 参数（兼容 /CommoditySearch 与分类自定义路由） */
    listPageKeyword() {
      if (this.$route.meta.shopGroupCategory) {
        return this.$route.meta.shopGroupCategory.translation_name || "";
      }
      return this.$route.query.keyword || this.$store.state.searchInfo || "";
    },
  },
  created() {
    this.form1688.descendOrder = false; //是否倒序;正序: false;倒序:true

    if (this.$route.query.type) {
      this.isImgSearch = true;
    }
    this.initialized();
  },
  watch: {
    $route: {
      handler(route) {
        // 兼容 /CommoditySearch 与分类自定义路由，路由变化时重新初始化搜索关键词
        if (this.$fun.isCommoditySearchRoute(route)) {
          if (this.$route.query.type == "imgSearch") {
            this.isImgSearch = true;
          } else {
            this.isImgSearch = false;
          }
          this.initialized();
        }
      },
    },
  },
  mounted() {
    window.addEventListener("scroll", this.scrollGetGoods);
  },
  destroyed() {
    window.removeEventListener("scroll", this.scrollGetGoods);
  },
  methods: {
    // 筛选数据
    filterData(data, Isnewregion) {
      this.shopType = data.shopType || "1688";

      this.form1688.page = 0;
      this.formTaobao.page = 0;

      this.list1688 = [];
      this.listTaobao = [];
      this.showList = [];
      this.fiData = data;

      this.finished1688 = false;
      this.finishedTaobao = false;

      this.goodsListIsNull1688 = false;
      this.goodsListIsNullTaobao = false;
      this.nodataFontOverride = null;

      this.timeout = false;
      this.loadKey++;
      this.getData(Isnewregion);
    },
    toTop() {
      window.scrollTo(0, 0);
    },
    openChat() {
      this.$fun.clickJs();
    },
    // 添加收藏商品
    favoriteGoodsAdd(item) {
      if (!this.$store.state.userInfo) {
        return this.$store.commit(
          "getshowLoginDialog",
          !this.$store.state.showLoginDialog,
        );
      }
      let datas = {
        goods_id: item.goods_id,
        title: item.title,
        image_url: item.imgUrl,
        price: item.goodsPrice,
        from_platform: item.shop_type,
      };
      if (!item.goodsFavoriteStatus) {
        this.$api.favoriteGoodsAdd(datas).then((res) => {
          if (res.code != 0) return;
          item.goodsFavoriteStatus = !item.goodsFavoriteStatus;
          this.$forceUpdate();
        });
      } else {
        this.$api
          .favoriteGoodsDelete({
            goods_id: item.goods_id,
          })
          .then((res) => {
            //console.log("favoriteGoodsDelete", res);
            if (res.code != 0) return;
            this.$message.success(this.$fanyi("移出收藏夹成功"));
            item.goodsFavoriteStatus = !item.goodsFavoriteStatus;
            this.$forceUpdate();
          });
      }
    },

    // 路由改变时的操作
    initialized() {
      const category = this.$route.meta.shopGroupCategory;
      /**
       * 分类自定义路由（meta.shopGroupCategory 由 buildShopGroupRoutes 注入）：
       * - keyWord 用 chinese_name 调搜索接口（与旧版 CN 参数逻辑一致，精确匹配）
       * - searchInfo 用 translation_name 供头部搜索框展示意大利语名称
       *
       * 普通 /CommoditySearch 仍走 query.CN / query.keyword 原有逻辑
       */
      if (category) {
        this.keyWord = category.chinese_name;
        this.$store.commit("getsearchInfo", category.translation_name);
      } else if (!!this.$route.query.CN) {
        //console.log(this.$route.query.CN);
        this.keyWord = this.$fun.fromCode(this.$route.query.CN);
      } else if (this.$route.query.keyword) {
        this.keyWord = this.$route.query.keyword;
      }
      this.finished1688 = false;
      this.finishedTaobao = false;

      // 非分类路由时，关键词仍从 query 同步到 vuex
      if (!category) {
        this.$store.commit("getsearchInfo", this.$route.query.keyword);
      }

      this.$forceUpdate();

      // this.getData();
    },
    // 获取列表数据
    async getData(Isnewregion) {
      if (!this.timeout) {
        let loadKey = this.loadKey;
        this.timeout = true;
        let funshopType = this.shopType;
        let res = {};
        let resList = [];

        if (funshopType == "1688") {
          if (this.finished1688) {
            return (this.timeout = false);
          }
          if (!this.form1688.page) {
            this.loading = true;
            this.form1688.page = 0;
          }
          this.form1688.page++;
        } else {
          // alibaba 国际阿里巴巴 / Taobao 淘宝 统一使用 formTaobao
          if (this.finishedTaobao) {
            return (this.timeout = false);
          }
          if (!this.formTaobao.page) {
            this.loading = true;
            this.formTaobao.page = 0;
          }
          this.formTaobao.page++;
        }

        // 关键词搜索 或 分类自定义路由，均走关键词搜索接口
        if (this.$route.query.keyword || this.$route.meta.shopGroupCategory) {
          let searchData = {
            keyWords: this.keyWord,
            shop_type: funshopType,
            page:
              funshopType == "1688" ? this.form1688.page : this.formTaobao.page,
            pageSize:
              funshopType == "1688"
                ? this.form1688.pageSize
                : this.formTaobao.pageSize,
            // group_id：query 优先；分类路由从 meta 取当前分类 id
            group_id:
              this.$route.query.group_id ||
              (this.$route.meta.shopGroupCategory &&
                this.$route.meta.shopGroupCategory.id),
          };
          // 筛选参数合并（所有平台都传）
          Object.keys(this.fiData).forEach((key) => {
            if (key != "region" && key != "shopType") {
              searchData[key] = this.fiData[key];
            }
          });

          searchData.outMemberId = this.$fun.setUserID();
          res = await this.$api.EuropeKeywordSearchProduct(searchData);
          if (res.code == "10010") this.nodataFontOverride = res.msg;

          resList = (res.data && res.data.result) || [];
        } else if (
          this.$route.query.type == "imgSearch" &&
          this.$route.query.imgUrl
        ) {
          let searchData = {
            shop_type: funshopType,
            picUrl: this.$route.query.imgUrl,
            imageId: this.$route.query.imageId,
            page:
              funshopType == "1688" ? this.form1688.page : this.formTaobao.page,
            pageSize:
              funshopType == "1688"
                ? this.form1688.pageSize
                : this.formTaobao.pageSize,
            outMemberId: this.$fun.setUserID(),
          };
          Object.keys(this.fiData).forEach((key) => {
            searchData[key] = this.fiData[key];
          });
          searchData.outMemberId = this.$fun.setUserID();
          res = await this.$api.imageSearchProductV2(searchData);
          if (
            res.data &&
            res.data.region &&
            res.data.region.length > 0 &&
            this.$refs.keywordSearchRef
          ) {
            this.$refs.keywordSearchRef.initialSelection =
              res.data.region[0].location;
            this.$refs.keywordSearchRef.getImageSliceList(
              res.data.region,
              Isnewregion,
            );
          }
          resList = res.data.data;
        }
        // loadKey用于防止用户快速点击筛选项引起多个请求并发导致显示结果混乱问题
        if (loadKey != this.loadKey) return false;
        this.timeout = false;
        this.loading = false;

        if (res.code != 0) {
          if (funshopType == "1688") {
            if (this.form1688.page == 1 && !this.list1688.length) {
              this.goodsListIsNull1688 = true;
            }
            this.finished1688 = true;
            return;
          } else {
            if (this.formTaobao.page == 1 && !this.listTaobao.length) {
              this.goodsListIsNullTaobao = true;
            }
            this.finishedTaobao = true;
            return;
          }
        }

        if (resList.length) {
          if (funshopType == "1688") {
            this.list1688 = [...this.list1688, ...resList];
          } else {
            this.listTaobao = [...this.listTaobao, ...resList];
          }
        }

        if (funshopType == "1688") {
          if (!resList || resList.length < this.form1688.pageSize) {
            if (
              this.form1688.page == 1 &&
              !(this.list1688.length + resList.length)
            ) {
              this.goodsListIsNull1688 = true;
            }
            this.finished1688 = true;
          }
        } else {
          // alibaba / Taobao
          if (!resList || resList.length < this.formTaobao.pageSize) {
            if (
              this.formTaobao.page == 1 &&
              !(this.listTaobao.length + resList.length)
            ) {
              this.goodsListIsNullTaobao = true;
            }
            this.finishedTaobao = true;
          }
        }
        if (funshopType != "alibaba") {
          this.favoriteGoodsCheckIn(res.data.result || res.data.data);
        }
        // 加载状态结束
        this.loading = false;
        if (funshopType == 1688) {
          this.showList = this.list1688;
          this.total1688 = res.data.total;
        } else {
          this.showList = this.listTaobao;
          this.totalTaobao = res.data.total;
        }
        this.$forceUpdate();
      }
    },

    // 查看店铺是否已收藏
    favoriteGoodsCheckIn(reli) {
      if (!reli) return;
      let ids = [];
      reli.forEach((goodsItem) => {
        goodsItem.goodsFavoriteStatus = false;
        ids.push(goodsItem.goods_id);
      });
      this.$api
        .favoriteGoodsCheckIn({
          goods_id: JSON.stringify(ids),
        })
        .then((res) => {
          if (res.code != 0) return false;
          res.data.forEach((resItem, resIndex) => {
            reli[resIndex].goodsFavoriteStatus = resItem.inFavorite;
          });
        });
      this.$forceUpdate();
    },

    // // 页面滑动事件
    scrollGetGoods() {
      let dd = document.documentElement || document.body;

      if (dd.offsetHeight <= dd.scrollTop + 2000) {
        this.getData();
      }
    },
  },
};
</script>
<style lang="scss" scoped="scoped">
@import "@/css/mixin.scss";
/deep/.el-image.biggoodsImg {
  $imgSize: 218px;
  width: $imgSize;
  height: $imgSize;
  transition: 0.3s;
  text-align: center;

  i {
    font-size: $imgSize/4;
    line-height: $imgSize;
  }
}
.SearchConterCrosswise {
  width: $pageWidth;
  display: flex;
  flex-wrap: wrap;
  margin: 0 auto;
  min-height: 500px;
  position: relative;
  /deep/.el-loading-mask {
    z-index: 10;
  }

  .SearchConterCrosswiseCon {
    margin-right: 20px;
    margin-bottom: 15px;
    position: relative;
    transition: 0.3s;
    background-color: white;
    width: 264px;
    // height: 373px;
    border: solid 1px #e8e8e8;
    box-shadow: 0px 4px 8px -2px rgba(16, 24, 40, 0.1),
      0px 2px 4px -2px rgba(16, 24, 40, 0.06);

    border-radius: 16px;
    overflow: hidden;
    cursor: pointer;
    &:hover {
      transform: translate(0, -5px);
      box-shadow: 0px 10px 20px #d1d1d1;

      .similarProducts {
        opacity: 1;
      }
    }

    &:nth-child(5n + 1) {
      margin-right: 0px;
    }

    .SearchConterCrosswiseImg {
      height: 214px;

      overflow: hidden;
      height: 214px;
      position: relative;

      > .goodsImg {
        background-color: transparent;
      }

      .el-image {
        transition: 0.3s;
        width: 260px;
        height: 260px;
      }
    }

    .rests {
      box-sizing: border-box;
      padding: 16px 16px 24px;

      p {
        font-size: 12px;

        font-weight: 400;
        color: #000000;

        &.goodsTitle {
          @extend .text-overflow-one;
          height: 23px;
          font-size: 14px;
          font-weight: 600;
          color: #475467;
        }

        &:nth-child(2) {
          font-size: 16px;
          font-weight: 600;

          color: #475467;
          > span {
            line-height: 24px;
            color: #009246;
            font-weight: 700;
            margin-right: 8px;
          }
        }

        .collect {
          display: flex;
          align-items: center;

          img {
            width: 20px;
            height: 20px;
            margin-right: 10px;
          }

          span {
            font-size: 14px;

            color: #888888;
            line-height: 20px;
          }
        }
      }
      .totalTagBox {
        @extend .text-overflow-one;
        border-radius: 6px;
        border: 1px solid var(--Rakumart-300, #bddbb8);
        background: var(--Rakumart-50, #eaf8e8);
        font-size: 13px;
        color: #009246;
        font-weight: 600;
        line-height: 24px;
        margin-bottom: 8px;
        padding-left: 4px;

        &:last-child {
          margin-bottom: 0px;
        }
      }
      .mt-16 {
        margin-top: 16px;
      }
    }
  }
}
.SearchConterVertical {
  width: $pageWidth;
  min-height: 300px;
  margin: 0 auto;

  > div {
    height: 200px;
    background: #ffffff;
    box-shadow: 0px 0px 10px 0px rgba(61, 61, 61, 0.1);
    border-radius: 4px;
    margin-bottom: 20px;
    padding: 20px;
    display: flex;
    position: relative;

    .goodsImg {
      width: 160px;
      height: 160px;
      margin-right: 20px;
      border-radius: 4px;
    }

    .VerticalInfo {
      display: flex;
      justify-content: space-between;
      flex-direction: column;
      align-items: flex-start;

      > span {
        &.vGoodsTitle {
          font-size: 16px;
          width: 90%;
          color: #000000;
          line-height: 24px;
        }

        &:last-child {
          font-size: 24px;
          display: flex;
          align-items: center;

          font-weight: bold;
          color: #009246;
          line-height: 36px;
          position: relative;

          > font {
            width: 150px;
            font-size: 14px;
            color: #888888;
            line-height: 20px;
            margin-left: 40px;
          }
          .RMBPrice {
            margin-left: 8px;
            color: #667085;
            font-size: 18px;
            font-weight: blob;
            line-height: 20px;
          }
        }
      }
    }

    .collect {
      position: absolute;
      right: 65px;
      top: 78px;
      text-align: center;
      cursor: pointer;

      img {
        width: 20px;
        height: 20px;
      }

      span {
        font-size: 14px;

        color: #888888;
        line-height: 20px;
      }
    }
  }
}
.loadingProBox {
  font-size: 20px;
  color: #888888;
  text-align: center;
  padding-bottom: 20px;
}
</style>
